import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Button, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

import { useHistory } from "react-router";
import { useLazyQuery } from "@apollo/client";

import { useTranslation } from "../../lang";
import POINT_GUIDENUMBER_QUERY from "../../graphql/queries/getPointGuidNumberQuery";
import "./Form.scss";

const Form = () => {
  const [t] = useTranslation();
  const history = useHistory();

  const [guideNumber, setGuideNumber] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const [resultState, setResultState] = useState({
    isOpen: false,
    type: "success",
    msg: "",
  });

  const handleChangeRecaptcha = () => {
    setIsCaptchaValid(true);
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") return;
    setResultState({ ...resultState, isOpen: false });
  };

  const [fetchPoint] = useLazyQuery(POINT_GUIDENUMBER_QUERY, {
    fetchPolicy: "network-only",
    onCompleted(d) {
      const p = d.getPoinGuideNumber;
      if (!p) {
        setResultState({
          isOpen: true,
          type: "error",
          msg: t("No se encontró el número de guia"),
        });
        return;
      }
      history.push("/cargoTracking", { point: p });
    },
    onError(err) {
      setResultState({ isOpen: true, type: "error", msg: err.message });
    },
  });

  return (
    <>
      <Snackbar
        open={resultState.isOpen}
        autoHideDuration={5000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseNotification}
          severity={resultState.type}
          variant="filled"
        >
          {resultState.msg}
        </MuiAlert>
      </Snackbar>

      <div className="login-panel">
        <div className="login-panel__logo">
          <img src="/assets/img/login_logo_sp3.png" alt="SP3" />
        </div>
        {/* <p className="login-panel__subtitle">{t("Seguimiento de Cargas")}</p> */}

        <div className="login__form">
          <div className="login-field-group">
            <label>{`${t("Número Guía")}:`}</label>
            <input
              type="text"
              value={guideNumber}
              onChange={(evt) => setGuideNumber(evt.target.value)}
            />
          </div>

          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
            onChange={handleChangeRecaptcha}
            theme="dark"
          />

          <Button
            className="login-submit-btn"
            variant="contained"
            disableElevation
            type="button"
            onClick={() => {
              fetchPoint({ variables: { GuideNumber: guideNumber } });
            }}
          >
            {t("Buscar Número de Guía")}
          </Button>
        </div>
      </div>
    </>
  );
}

export default Form;

